export class InternalServerError extends Error {
  constructor(e = "サーバーでエラーが発生しています") {
    super(e)
    this.name = new.target.name;
  }
}
